import React, { Component } from 'react';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { bindActionCreators } from 'redux';
import * as actions from '../../actions/language.actions';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

// eslint-disable-next-line
import style from './_style.css';

import spain from '../../images/spain.svg';
import uk from '../../images/uk.svg';

class FlagButton extends Component {
    state = {
        anchorEl: null,
    };

    handleClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = (language) => {
        this.props.setLang(language);
        //this.props.history.push(this.props.url);
        this.setState({ anchorEl: null });
    };

    render() {
        const { intl } = this.props;
        const { anchorEl } = this.state;

        let flag = uk;
        if (intl.formatMessage({ id: 'locate' }) === 'es') {
            flag = spain;
        }

        return (
            <div className={'root-flag'}>
                <div onClick={this.handleClick}>
                    <img src={flag} className={'flag'} alt="flag" />
                </div>
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose}
                >
                    <MenuItem
                        className={'barlow_semibold_button c_bluish buttonhover'}
                        onClick={this.handleClose.bind(this, 'es')}
                        onMouseEnter={(e) => (e.target.style.backgroundColor = '#eff9ff')}
                        onMouseLeave={(e) => (e.target.style.backgroundColor = '#ffffff')}
                    >
                        Español
                    </MenuItem>
                    <MenuItem
                        className={'barlow_semibold_button c_bluish buttonhover'}
                        onClick={this.handleClose.bind(this, 'en')}
                        onMouseEnter={(e) => (e.target.style.backgroundColor = '#eff9ff')}
                        onMouseLeave={(e) => (e.target.style.backgroundColor = '#ffffff')}
                    >
                        English
                    </MenuItem>
                </Menu>
            </div>
        );
    }
}

FlagButton.propTypes = {
    intl: intlShape.isRequired,
    locales: PropTypes.shape({
        lang: PropTypes.string.isRequired,
    }).isRequired,
    history: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actions, dispatch);
}

function mapStateToProps(state) {
    return {
        locales: state.locales,
    };
}
FlagButton = withRouter(FlagButton);
FlagButton = injectIntl(FlagButton);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(FlagButton);



// WEBPACK FOOTER //
// ./src/components/buttons/FlagButton.js